import React, { useState } from 'react';
import moment from 'moment';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';
import 'react-datepicker/dist/react-datepicker.css';

export function DatePickerElement({
  label,
  requiredField,
  fromForm,
  duplicatingItem,
  index,
  i,
  id,
  eleIndex,
  elekey,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  value,
  onChange,
  placeHolder,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };

  return (
    <div className="dt_picker position-relative" onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
      <label className={`asterisk-req ${fromForm && 'd-flex'}`}>
        {label}
        {requiredField && <span>*</span>}
      </label>
      <CustomDatePicker
        keyProp={`_${eleIndex}_${i}_${index}`}
        dateFormat="dd-MMM-yyyy"
        popperPlace="top-end"
        disable={disable}
        name="selectedDate"
        placeholder={placeHolder}
        valueProp={value}
        onChange={(e) => onChange(moment(new Date(e)).format('DD-MMM-YYYY'), label, i, eleIndex, index)}
      />
      {fromForm && isOver && (
        <div className="potemp-action-btns">
          <button
            type="button"
            className="btn btn-border ml-auto  py-0 px-1"
            key={`_${eleIndex}_${i}_${index}_edit`}
            onClick={() => editingInput(index, i, eleIndex)}
          >
            <span className="icon-edit" />
          </button>
          {showDelete && isOver && (
            <button
              type="button"
              className="btn btn-border  py-0 px-1"
              key={`_${eleIndex}_${i}_${index}_delete`}
              onClick={() => deleteItem(index, i, elekey, eleIndex)}
            >
              <span className="icon-delete" />
            </button>
          )}
          <button
            type="button"
            className="btn btn-border  py-0 px-1"
            key={`_${eleIndex}_${i}_${index}_duplicate`}
            onClick={() => (fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey, fromCustomSection))}
          >
            <span className="icon-copy" />
          </button>
        </div>
      )}
    </div>
  );
}
export default DatePickerElement;
